import React from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { STRINGS } from '@/app/constants/componentStrings';
import Formatacao from '@/app/util/formatacao'
import {Dialog} from 'primereact/dialog';
import { Button } from 'primereact/button';
import DocumentImageService from '@/app/api/service/DocumentImageService';


function OrdensServico( props ){

    const [state, setState] = React.useState({
        showDialog: false,
        ordemSelecionada: { documentos:[] }
    })

    const documentacaoColumnTemplate = (rowData, column) => {
        return <Button onClick={e => showDocuments(rowData)} label="Documentação" type="button" icon="pi pi-folder-open" className="p-button-success"></Button>
    }

    const showDocuments = (ordem) => {
        setState({
            ordemSelecionada: ordem,
            showDialog: true
        })
    }

    return(
        <React.Fragment>
            <DataTable value={props.list} emptyMessage={STRINGS.emptyMessage}>
                <Column field={"numero"} header={"Número"} />
                <Column header={"Data"} body={ (rowData) => <span>{Formatacao.localDate(rowData.data)}</span> } />
                <Column header={"Tipo"} body={ (rowData) => <span>{rowData.tipo && rowData.tipo.descricao}</span> } />
                <Column field={"quantidadeDias"} header={"Qtd. Dias"} />
                <Column header="" body={documentacaoColumnTemplate} className="t-center"/>     
            </DataTable>

            <Dialog header="Imagens da Ordem de Serviço" 
                    style={{ width: '800px' }}
                    visible={state.showDialog} modal={true} 
                    onHide={(e) => setState({showDialog: false, ordemSelecionada: {documentos:[]}})}>

                <DataTable value={state.ordemSelecionada.documentos} emptyMessage={STRINGS.emptyMessage} 
                           rows={10} alwaysShowPaginator={false}
                           paginator={true} paginatorPosition="bottom" >
                    <Column field="descricaoTipoDocumento" header="Documento" />
                    <Column field="nomeArquivo" header="Arquivo" />
                    <Column className="coluna-acao" body={
                        (data) => (
                            <Button type="button"
                                onClick={ e => { e.preventDefault(); DocumentImageService.visualizarDocumento('ordem-servico', data.id)} }
                                icon="pi pi-download" 
                                className="p-button-primary"
                                style={{marginRight: '.5em'}}>
                            </Button>
                        )
                    } />
                 
                </DataTable>
            </Dialog>
        </React.Fragment>
    )
}

export default OrdensServico;